/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreporttypelisting3Inputs */

const en_contentreporttypelisting3 = /** @type {(inputs: Contentreporttypelisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

const de_contentreporttypelisting3 = /** @type {(inputs: Contentreporttypelisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Listing" |
*
* @param {Contentreporttypelisting3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreporttypelisting3 = /** @type {((inputs?: Contentreporttypelisting3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreporttypelisting3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreporttypelisting3(inputs)
	return de_contentreporttypelisting3(inputs)
});
export { contentreporttypelisting3 as "contentReportTypeListing" }